import { useQuery } from "Web/Hooks/URL/URLUtils";

export type RouteParams = { projectId: string; configId: string; }

export type RouteQueryParams = {
    version: string;
    ref: string;
    access_token: string;
    refresh_token: string;
    token_type: string;
    remove_token: string;
    configId: string;
}

export const useVersion = () => useQuery<RouteQueryParams>().version;
